import createIcon from '../../createIcon';

/**
 * @component @name SpatialAudio
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOS41IDE0QzExLjcwOTEgMTQgMTMuNSAxMi4yMDkxIDEzLjUgMTBDMTMuNSA3Ljc5MDg2IDExLjcwOTEgNiA5LjUgNkM3LjI5MDg2IDYgNS41IDcuNzkwODYgNS41IDEwQzUuNSAxMi4yMDkxIDcuMjkwODYgMTQgOS41IDE0WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE1Ljg5IDE2LjU2QzE0LjIxIDE1LjcgMTIuMDMgMTUgOS41IDE1QzYuOTcgMTUgNC43OSAxNS43IDMuMTEgMTYuNTZDMi4xMSAxNy4wNyAxLjUgMTguMSAxLjUgMTkuMjJWMjJIMTcuNVYxOS4yMkMxNy41IDE4LjEgMTYuODkgMTcuMDcgMTUuODkgMTYuNTZaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTUuNSAySDEzLjVDMTMuNSA2Ljk3IDE3LjUzIDExIDIyLjUgMTFWOUMxOC42NCA5IDE1LjUgNS44NiAxNS41IDJaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTkuNSAySDE3LjVDMTcuNSA0Ljc2IDE5Ljc0IDcgMjIuNSA3VjVDMjAuODUgNSAxOS41IDMuNjUgMTkuNSAyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SpatialAudio = createIcon('SpatialAudio', [
  [
    'path',
    {
      d: 'M9.5 14C11.7091 14 13.5 12.2091 13.5 10C13.5 7.79086 11.7091 6 9.5 6C7.29086 6 5.5 7.79086 5.5 10C5.5 12.2091 7.29086 14 9.5 14Z',
      key: '1gcv8w',
    },
  ],
  [
    'path',
    {
      d: 'M15.89 16.56C14.21 15.7 12.03 15 9.5 15C6.97 15 4.79 15.7 3.11 16.56C2.11 17.07 1.5 18.1 1.5 19.22V22H17.5V19.22C17.5 18.1 16.89 17.07 15.89 16.56Z',
      key: '133srz',
    },
  ],
  [
    'path',
    { d: 'M15.5 2H13.5C13.5 6.97 17.53 11 22.5 11V9C18.64 9 15.5 5.86 15.5 2Z', key: '1324d9' },
  ],
  [
    'path',
    { d: 'M19.5 2H17.5C17.5 4.76 19.74 7 22.5 7V5C20.85 5 19.5 3.65 19.5 2Z', key: '1vwz7z' },
  ],
]);

export default SpatialAudio;
